export const getMandatoryBreak = (row) => {
	const calculationGroup = row?.calculationGroup || row?.user?.calculationGroup;
	return (!!calculationGroup?.breaks?.manual?.status && !!calculationGroup?.breaks?.manual?.mandatory)
		? calculationGroup.breaks.manual
		: null;
}

export const isMandatoryBreakViolated = (timesheet, breakRule) => {
	if (
        !timesheet?.payCode?.id
        || !breakRule?.mandatory
        || !breakRule?.duration
        || !breakRule?.payCode?.id
    ) {
        return false;
    }
    const duration = Number(timesheet.duration);
    const mandatoryDuration = Number(breakRule.duration) * 60;

    return (
        (duration  < mandatoryDuration)
        && timesheet.payCode.id === breakRule.payCode.id
    );
}
